export default "__VITE_ASSET__33845fc3__"